import { jsx, jsxs } from 'react/jsx-runtime';
import cx from 'clsx';
import { useRef, useState, useEffect, Children } from 'react';
import { u as useFixedPosition } from './hook-CckkA92z.js';
import { u as useLatest } from './hook-BihLfH9C.js';
import { s as styleInject } from './style-inject.es-tgCJW-Cu.js';

var css_248z = ".SGCM_UIKIT_REACT_AbsolutePositionAligner_containerRoot_xi9pe_1 {\n  position: relative;\n}\n\n.SGCM_UIKIT_REACT_AbsolutePositionAligner_containerLocate_xi9pe_5 {\n  display: contents;\n}\n\n.SGCM_UIKIT_REACT_AbsolutePositionAligner_containerTarget_xi9pe_9 {\n  position: absolute;\n  opacity: 0;\n  visibility: hidden;\n}\n.SGCM_UIKIT_REACT_AbsolutePositionAligner_containerTarget_xi9pe_9.SGCM_UIKIT_REACT_AbsolutePositionAligner_isInitialized_xi9pe_14 {\n  opacity: unset;\n  visibility: unset;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGtCQUFrQjtBQUNwQjs7QUFFQTtFQUNFLGlCQUFpQjtBQUNuQjs7QUFFQTtFQUNFLGtCQUFrQjtFQUNsQixVQUFVO0VBQ1Ysa0JBQWtCO0FBQ3BCO0FBQ0E7RUFDRSxjQUFjO0VBQ2QsaUJBQWlCO0FBQ25CIiwiZmlsZSI6InN0eWxlcy5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXJSb290IHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuXG4uY29udGFpbmVyTG9jYXRlIHtcbiAgZGlzcGxheTogY29udGVudHM7XG59XG5cbi5jb250YWluZXJUYXJnZXQge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIG9wYWNpdHk6IDA7XG4gIHZpc2liaWxpdHk6IGhpZGRlbjtcbn1cbi5jb250YWluZXJUYXJnZXQuaXNJbml0aWFsaXplZCB7XG4gIG9wYWNpdHk6IHVuc2V0O1xuICB2aXNpYmlsaXR5OiB1bnNldDtcbn0iXX0= */";
var styles = {"containerRoot":"SGCM_UIKIT_REACT_AbsolutePositionAligner_containerRoot_xi9pe_1","containerLocate":"SGCM_UIKIT_REACT_AbsolutePositionAligner_containerLocate_xi9pe_5","containerTarget":"SGCM_UIKIT_REACT_AbsolutePositionAligner_containerTarget_xi9pe_9","isInitialized":"SGCM_UIKIT_REACT_AbsolutePositionAligner_isInitialized_xi9pe_14"};
styleInject(css_248z);

const AbsolutePositionAligner = ({ children, className, isActive, offset, rectCalculator, targetElement, targetElementClassName, autoLocate = true, onLocateElementWidthChange, }) => {
    const locateContainerElementRef = useRef(null);
    const locateElementRef = useRef(null);
    const targetElementRef = useRef(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const { rect, refreshRect } = useFixedPosition({
        locateElementRef,
        targetElementRef,
        rectCalculator,
    });
    const { ref: onLatestLocateElementWidthChangeRef } = useLatest({
        value: onLocateElementWidthChange,
    });
    useEffect(() => {
        if (!isActive) {
            setIsInitialized(false);
            return;
        }
        if (isInitialized) {
            return;
        }
        const locateElement = locateContainerElementRef.current
            ?.firstElementChild;
        if (!locateElement) {
            return;
        }
        locateElementRef.current = locateElement;
        refreshRect();
        setIsInitialized(true);
    }, [
        isActive,
        isInitialized,
        refreshRect,
    ]);
    useEffect(() => {
        if (!isInitialized) {
            return undefined;
        }
        const { current: locateElement } = locateElementRef;
        if (!locateElement) {
            return undefined;
        }
        const observer = new ResizeObserver(([{ contentRect: { width, }, },]) => {
            onLatestLocateElementWidthChangeRef.current?.(width);
        });
        observer.observe(locateElement);
        onLatestLocateElementWidthChangeRef.current?.(locateElement.clientWidth);
        return () => {
            observer.disconnect();
        };
    }, [
        isInitialized,
        onLatestLocateElementWidthChangeRef,
    ]);
    if (Children.count(children) !== 1) {
        throw new TypeError('Number of children should be one');
    }
    if (!isActive) {
        return (jsx("div", { className: styles.containerRoot, children: children }));
    }
    return (jsxs("div", { className: styles.containerRoot, children: [jsx("div", { ref: locateContainerElementRef, className: cx(styles.containerLocate, className), children: children }), jsx("div", { ref: targetElementRef, className: cx(styles.containerTarget, {
                    [styles.isInitialized]: isInitialized,
                }, targetElementClassName), style: rect
                    ? {
                        left: autoLocate
                            ? rect.left + (offset?.left ?? 0)
                            : (offset?.left ?? 0),
                        top: autoLocate
                            ? rect.top + (offset?.top ?? 0)
                            : (offset?.top ?? 0),
                    }
                    : undefined, children: targetElement })] }));
};

export { AbsolutePositionAligner as A };
//# sourceMappingURL=component-Drqwk5-1.js.map
